module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service_part.field.claim.num_request":"ขอเคลม","service_part.field.claim.num_approved":"อนุมัติ","service_part.field.claim.num_concluded":"เคลม","service_part.list.add":"เพิ่มรายการอะไหล่","service_part.empty":"ไม่มีรายการอะไหล่"}}')
  delete Component.options._Ctor
}
